import { decodeToken, getToken } from "../utils/TokenUtils";
import { API_URL,ENDPOINTS,getData,postData } from "../constants/api";
import { useParams } from "react-router-dom";
import { useState,useEffect } from "react";

export const ComplaintLetter=() =>{
    const {route,id}=useParams();
    const [data,setData]=useState();

    const token=getToken();
    const logo=decodeToken(token,'logo');
    const banner=decodeToken(token,'banner');
    const companyName=decodeToken(token,'companyName');
    const userId=decodeToken(token,'id');
 
  const header = data?.find((d) => d.title === 'header')?.fields || {};
  const complaint = data?.find((d) => d.title === 'complaint')?.fields || {};
  useEffect(()=>{
    const fetchData=async ()=>{
        const url=`${API_URL}/${ENDPOINTS.SYS}/activityReport/${route}`;
        const res=await postData(url,{id,user_id:userId});
        setData(res.data);
        // console.log('res : ',res.data);
    }
    fetchData();
  },[route,id])

 return (
  <>
   <style>{`
  /* ===== A4 PAGE ===== */
  .letter-container {
    width: auto;
    min-height: 148.5mm;
    margin: auto;
    background: #ffffff;
    padding: 22mm 18mm;
    border: 1px solid #dcdcdc;
    font-family: "Arial", sans-serif;
    font-size: 14px;
    color: #000;
    position: relative;
  }

  /* ===== HEADER ===== */
  .letter-header {
    border-bottom: 2px solid #000;
    padding-bottom: 14px;
    margin-bottom: 22px;
  }

  .letter-logo {
    height: 72px;
    max-width: 100%;
    object-fit: contain;
  }

  .company-name {
    font-size: 19px;
    font-weight: 700;
    letter-spacing: 0.6px;
    text-align: center;
  }

  .company-info p {
    margin: 0;
    line-height: 1.55;
    font-size: 13.5px;
  }

  /* ===== TABLE ===== */
  .letter-table {
    margin-top: 20px;
    font-size: 14px;
  }

  .letter-table th {
    width: 32%;
    background-color: #f3f3f3;
    font-weight: 600;
    padding: 11px;
    vertical-align: middle;
  }

  .letter-table td {
    padding: 11px;
    vertical-align: middle;
  }

  /* ===== FOOTER ===== */
  .letter-footer {
    position: absolute;
    bottom: 18mm;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 12px;
    color: #666;
  }

  /* ===== RESPONSIVE (SCREEN ONLY) ===== */
  @media screen and (max-width: 768px) {
    .letter-container {
      width: 100%;
      min-height: auto;
      padding: 16px;
      border: none;
    }

    .letter-header {
      text-align: center;
    }

    .company-name {
      font-size: 17px;
    }

    .company-info {
      text-align: center !important;
      margin-top: 12px;
    }

    .letter-table {
      font-size: 13px;
    }

    .letter-footer {
      position: static;
      margin-top: 30px;
    }
  }

  /* ===== PRINT ===== */
  @media print {
    body {
      background: none;
    }
  /* width: 210mm;
      min-height:148.5mm; */
    .letter-container {
      border: none;
      margin: 0;
      width: 210mm;
      min-height:148.5mm;
    }

    .letter-footer {
      position: absolute;
      bottom: 18mm;
    }
  }
`}</style>



    <div className="letter-container position-relative">
  
  {/* HEADER */}
  <div className="row letter-header align-items-center">
  <div className="col-md-6 col-12 d-flex flex-column align-items-center gap-2">
    {banner && (
      <img
        src={`${API_URL}/${banner}`}
        alt="Logo"
        className="letter-logo"
      />
    )}
    <div className="company-name">{companyName}</div>
  </div>

  <div className="col-md-6 col-12 text-md-end text-center company-info mt-3 mt-md-0">
    {Object.entries(header).map(([key,val])=>
    <p><strong>{key}: </strong> {val}</p>
    )
    }
  </div>
</div>


  {/* BODY TABLE */}
  <table className="table table-bordered letter-table">
    <tbody>
       {Object.entries(complaint).map(([key,val])=>
        <tr>
          <th>{key}</th>
           <td>{val}</td>
    </tr>
    )
    }
      
    </tbody>
  </table>

  {/* FOOTER */}
  <div className="letter-footer">
    Powered by Kaafiye Technology Center (KTC) – www.kaafiye.com
  </div>

</div>

  </>
);

}
